import { ReactNode } from "react";

import { ProductMenu } from "./ProductMenu";
import { ProductMenuItem, WorkspaceSelectorProps } from "./types";

// Product rail (optional) + side menu + the page. The side menu reserves its own width in the
// page flow. The content's width also caps its minimum width in the flex row, which keeps wide
// pages (tables) from pushing the layout wider than the window.
export const SidebarAppLayout = ({
  appMenu,
  children,
  productItems,
  workspace
}: {
  appMenu: ReactNode;
  children?: ReactNode;
  productItems?: ProductMenuItem[];
  workspace?: WorkspaceSelectorProps;
}) => {
  const menuWidth = productItems ? 216 + 50 : 216;

  return (
    <div style={{ display: "flex" }}>
      {productItems && <ProductMenu items={productItems} workspace={workspace} />}
      {appMenu}
      <div style={{ flex: 1, width: `calc(100% - ${menuWidth}px)` }}>{children}</div>
    </div>
  );
};
